import {Image, Link, useCart} from '@shopify/hydrogen';
import heart from '../../assets/image/heart.svg';
import heartRed from '../../assets/image/heart-red.svg';
import CouponModalComponent from '../../components/modal/Coupon.client';
import {useState} from 'react';
import {useEffect} from 'react';
import { fetchSanityData, fectServiceApi } from '../../lib/fetchServiceApi';
import { makeUrlSite } from '../../lib/Utils';
import { sendPulseEvent } from '../../services/dru-id/pulse.client';

export default function ProductBookmark({
  product,
  customer,
  customerAccessToken,
  is_draft
}) {

  const [isItemWishlist, setItemWishlist] = useState();
  const [fromResultsPage, setFromResultPage] = useState(null);
  const [fromOfferPage, setOfferPage] = useState(null);
  const [showCouponModal, setShowCouponModal] = useState(false);
  const [pageViewCount, setPageVisitCount] = useState(0);
  const [wishListUser, setWIshListUser] = useState([]);

  const cart = useCart();
  const searchUrl = makeUrlSite('search?origin=product');
  let pageUrl = '';


  useEffect(() => {
    // Fix Window
    pageUrl = window.localStorage.getItem('pageUrl') ?? '';
  }, []);

  const isNovedadesSection = ()=>{
    if(pageUrl.indexOf('novedades') > -1){
      return pageUrl;
    }
  }

  const isBack = () =>{
    if(!isNovedadesSection() && pageUrl.indexOf('search') < 1){
      return true;
    }
  }
  
  const checkResultPage = (url) => {
    const resultPaths = ['categoria-producto', 'etiqueta-producto', 'search'];
    resultPaths.forEach((item) => {
      if (url.includes(item)) {
        setFromResultPage(url);
      }
    });
  };

  const checkOfferPage = (url) => {
    const resultPaths = ['/ofertas'];
    resultPaths.forEach((item) => {
      if (url.includes(item)) {
        setOfferPage(url);
      }
    });
  };

  const handleHistoryURL = () => {
    const pathname = window.localStorage.getItem('pageUrl')
    
    if (pathname) {
      checkResultPage(pathname);
      checkOfferPage(pathname);
      return pathname ? pathname : '';
    }

    return '';
  };

  const handlePageview = () => {
    const pv = sessionStorage.getItem('pageViewCount');
    const pageViewCount = pv ? parseInt(pv) : 0;
    sessionStorage.setItem('pageViewCount', pageViewCount + 1);

    setPageVisitCount(pv);
    if (!customerAccessToken) {
      pv == 2 && setShowCouponModal(true);
    }
  };
  
  useEffect(() => {
    handlePageview();
    if(customer?.wishlist?.value){
      setWIshListUser(JSON.parse(customer.wishlist.value))
    }
  }, []);
  
  async function onAddToWishList(productId, customerId) {
    let data = fectServiceApi('/api/shopify/wishlist', {func: 'listProductsUser', access: customerAccessToken});
    data.then((response)=>{
      let wishListUser = response.value ? JSON.parse(response.value): [];
      let currentProducts = wishListUser;
      
      if(wishListUser.indexOf(productId) > -1){
        currentProducts = currentProducts.filter(item => item !== productId);
        setWIshListUser(currentProducts);
        setItemWishlist(false);
      }else{
        currentProducts = [productId, ...wishListUser];
        setWIshListUser(currentProducts)
        setItemWishlist(true);

        sendPulseEvent('addProductWishList', {
          "objectDisplayName": "Agregar a lista de deseo",
          "targetDisplayName": "wishlist",
          "originDisplayName": "pagina producto",
          "product": product
        });
      }

      currentProducts = currentProducts.filter((value, index, self) => {
        return self.indexOf(value) === index;
      });

      fetch(`https://api.ellibrero.com/api/wishlist/mutate`,
      {
        method: 'POST',
        headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8',
      },
        body: JSON.stringify({productId: currentProducts, customerId: customerId?.id}),
      },
      )
      .then((res) => {
      })
      .catch((error) => {
      });
    })
  }

  const handleCloseCouponModal = () => {
    setShowCouponModal(false);
  };

  useEffect(() => {
    try {
      handleHistoryURL();
      const productExistWishList = customer?.wishlist
        ? JSON.parse(customer.wishlist.value).find((item) => item == product.id)
        : false;

      setItemWishlist(productExistWishList); 
    } catch (error) {}
  }, []);

  return (
    <div className="products-topbar flex border-b-gray-80 py-3 px-10 border xs:px-5 xs:py-3 xs:justify-between bg-white">
      {showCouponModal && (
        <CouponModalComponent onCloseModal={handleCloseCouponModal} />
      )}
      {is_draft ? (<>
        <a
          href={"/"}
          className="font-medium text-xs underline text-purple-120"
          id="return-search"
        >
          Ir a inicio
        </a>
      </>):
      isBack() ? (
        <a
          href="#"
          onClick={()=>{ try{ history.back(); }catch(e){} }}
          className="font-medium text-xs underline text-purple-120"
          id="return-search"
        >
        Regresar a la búsqueda
      </a>
      ):
      searchUrl || isNovedadesSection() ? (
        <a
          href={isNovedadesSection()  ?? searchUrl}
          className="font-medium text-xs underline text-purple-120"
          id="return-search"
        >
          Regresar a la búsqueda
        </a>
      ) : null}
      {fromOfferPage ? (
        <a
          href={fromOfferPage}
          className="font-medium text-xs underline text-purple-120"
          id="return-search"
        >
          Regresar a la seccion de ofertas
        </a>
      ) : null}
      <button
        className="btn-wishlist text-xs font-medium flex items-center ml-8"
        onClick={() => onAddToWishList(product.id, customer)}
      >
        {!is_draft && (<>
          <span>Wishlist</span>
          {isItemWishlist ? (
            <>
              <span className="wishlistIcon wishlistActive"></span>
              <Image
                src={heartRed}
                height={15}
                width={15}
                className="ml-2 hidden"
                alt="wishlist"
              />
            </>
          ) : (
            <>
              <span className="wishlistIcon"></span>
              <Image
                src={heart}
                height={15}
                width={15}
                className="ml-2 mb-1 hidden"
                alt="wishlist"
              />
            </>
          )}
        </>)}
      </button>
    </div>
  );
}
